import { Fab, Stack, Typography } from "@mui/material";
import React from "react";

const dayOptions = [
  { label: "S", value: 0 },
  { label: "M", value: 1 },
  { label: "T", value: 2 },
  { label: "W", value: 3 },
  { label: "T", value: 4 },
  { label: "F", value: 5 },
  { label: "S", value: 6 },
];

interface IProps {
  selectedDays: number[];
  setSelectedDays: (days: number[]) => void;
  disabled?: boolean;
  single?: boolean;
}

export const DayPicker = (props: IProps) => {
  const { disabled, selectedDays, setSelectedDays, single } = props;

  const handleSelectDay = (value: number) => {
    if (single) {
      setSelectedDays([value]);
    } else {
      if (selectedDays.includes(value)) {
        if (selectedDays.length > 1)
          setSelectedDays(selectedDays.filter((day) => day !== value));
      } else {
        setSelectedDays([...selectedDays, value]);
      }
    }
  };

  return (
    <Stack direction="row">
      {dayOptions.map((day) => (
        <Fab
          disabled={disabled}
          key={`${day.label}-${day.value}`}
          size="small"
          onClick={() => handleSelectDay(day.value)}
          color={selectedDays.includes(day.value) ? "primary" : "default"}
          sx={{ mx: 1 }}
        >
          <Typography fontSize="1rem" fontWeight="bold">
            {day.label}
          </Typography>
        </Fab>
      ))}
    </Stack>
  );
};
